import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a508f9be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "popup information" }
const _hoisted_2 = { class: "popup-header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "label" }
const _hoisted_5 = { class: "popup-footer" }

import GenericButton from "@/components/buttons/GenericButton.vue";
import PopupCancelButton from "@/components/popup/PopupCancelButton.vue";
import { GenericButtonVariantEnum } from "@/types/button";

interface Props {
  title?: string;
  label?: string;
  btnText?: string;
  cancelBtnText?: string;
  action: () => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PopupInfo',
  props: {
    title: { default: "" },
    label: { default: "" },
    btnText: { default: "" },
    cancelBtnText: { default: "" },
    action: { type: Function, default: () => {} }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t(_ctx.title)), 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t(_ctx.label)), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(PopupCancelButton, {
        text: _ctx.cancelBtnText,
        variant: _unref(GenericButtonVariantEnum).Primary
      }, null, 8, ["text", "variant"]),
      _createVNode(GenericButton, {
        variant: _unref(GenericButtonVariantEnum).Terciary,
        text: _ctx.btnText,
        "on-click": _ctx.action
      }, null, 8, ["variant", "text", "on-click"])
    ])
  ]))
}
}

})